module.exports = __webpack_public_path__ + "img/331.ba690629.png";